module.exports = __webpack_public_path__ + "static/img/build-blast2.175d0c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/build-blast2.jpg
// module id = V4Xh
// module chunks = 1